import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-scheduling",
  "use": "icon-scheduling-usage",
  "viewBox": "0 0 1075 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1075 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-scheduling\"><path d=\"M1014.85714299 678.86323833l-265.045333-161.475048v92.647619h-453.485715a78.262857 78.262857 0 1 1 79.945143-78.287238v41.984h127.878095v-42.032762a207.896381 207.896381 0 1 0-207.847619 203.532191h453.485715v105.130666zM378.75809499 972.19047633h127.902476v-197.485714H378.75809499V972.19047633z m174.128762 0h127.926857v-197.485714h-127.878095z m0-399.164953h127.926857V305.20076233h95.939048L611.83999999 45.71428533l-164.815238 259.486477h106.032762v267.824761z\" fill=\"#409EFF\" p-id=\"14482\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/scheduling.svg
// module id = 4aZa
// module chunks = 39